export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
		{
			key: 'saldo',
			type: 'number',
			is_price: true,
			only_show: true,
		},
		{
			text: 'Moneda',
			key: 'moneda_id',
			type: 'select',
			use_store_models: true,
			value: 1,
			if_has_extencion: 'ventas_en_dolares',
		},
		{
			text: 'Sucursal/Deposito',
			key: 'address_id',
			type: 'select',
			relation_prop_name: 'street',
			use_store_models: true,
			// if_has_extencion: 'resumen_caja',
		},
		{
			text: 'Empleado',
			key: 'employee_id',
			type: 'select',
			use_store_models: true,
			descriptions: [
				'Complete solo en caso de que quiera asignar esta caja a un unico empleado',
			]
			// if_has_extencion: 'resumen_caja',
		},
		{
			text: 'Fecha apertura',
			key: 'abierta_at',
			type: 'date',
			is_date: true,
			only_show: true,
		},
		{
			text: 'Fecha cierre',
			key: 'cerrada_at',
			type: 'date',
			is_date: true,
			only_show: true,
		},
		{
			key: 'abierta',
			type: 'checkbox',
			only_show: true,
		},
		// {
		// 	text: 'Metodos de pago vinculados',
		// 	store: 'current_acount_payment_method',
		// 	search_on_models_by: 'name',
		// 	type: 'search',
		// 	key: 'current_acount_payment_methods',
		// 	belongs_to_many: {
		// 		model_name: 'current_acount_payment_method',
		// 	}
		// },
		{
			text: 'Empleados con acceso',
			store: 'employee',
			search_on_models_by: 'name',
			type: 'search',
			key: 'users',
			belongs_to_many: {
				model_name: 'users',
				props_to_show: [
					{
						text: 'Nombre',
						key: 'name',
					}
				],
			}
		},
		{
			text: 'Visibilidad en tesorería',
			store: 'employee',
			search_on_models_by: 'name',
			type: 'search',
			key: 'treasury_users',
			descriptions: [
				'Si no agrega empleados aquí, se usa la lista de «Empleados con acceso». Si ambas listas quedan vacías, todos los empleados ven la caja en tesorería.',
			],
			belongs_to_many: {
				model_name: 'users',
				props_to_show: [
					{
						text: 'Nombre',
						key: 'name',
					}
				],
			}
		},
	],
	singular_model_name_spanish: 'Caja',
	plural_model_name_spanish: 'Cajas',
	create_model_name_spanish: 'Nueva Caja',
	color_display_function: true,
	text_delete: 'la',
}